import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  maps: [],
  allMaps: [],
  totalPages: 0,
  totalRecords: 0,
  map: null,
  errorStatus: null,
  reverseGeoCode: '',
  geoCode: null,
};
const getters = {
  getApiLoad_44: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_Maps(state, maps) {
    state.maps = maps.items;
    state.totalPages = maps.totalPages;
    state.totalRecords = maps?.totalRecords ?? 0;
  },
  SET_AllMaps(state, maps) {
    state.allMaps = maps;
  },
  SET_Map(state, map) {
    state.map = map;
  },
  SET_MapReverseGeoCode(state, data) {
    state.reverseGeoCode = data;
  },
  SET_MapGeoCode(state, data) {
    state.geoCode = data;
  },
};
const actions = {
  errorMap({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      }
    }
  },
  getMapGeoCode({ commit, dispatch, rootState }, text) {
    return apiClient.get('/Maps/Search?Term=' + text, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } }).then(response => {
      commit('SET_MapGeoCode', response.data);
      commit('SET_Status', true);
    }).catch(error => {
      dispatch('errorMap', error);
    });
  },
  getMapReverseGeoCode({ commit, dispatch, rootState }, { lat, lng }) {
    return apiClient.get('/Maps/ReverseGeoCode?Latitude=' + lat + "&Longitude=" + lng, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } }).then(response => {
      commit('SET_MapReverseGeoCode', response.data);
      commit('SET_Status', true);
    }).catch(error => {
      dispatch('errorMap', error);
    });
  },
}
export default {
  mutations,
  getters,
  state,
  actions,
};
